import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDirectIncomeLedgerApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchDirectIncomeBalanceLedger = createAsyncThunk(
  "directIncomeBalanceLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getDirectIncomeLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDirectIncomeAccountsBySearch = createAsyncThunk(
  "directIncomeBalanceLedger/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["direct_income"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
